import React from 'react';
import { FaFacebookSquare } from 'react-icons/fa';
import SharedHeader from '../../../components/SharedHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import UnderConstruction from '../../../components/UnderConstruction';
import './social_marketing.css';

const SocialMarketing = () => {
  return (
    <div className="social_marketing_page">
      <SharedHeader />
      
      <div className="social_marketing_container">
        <header className="social_marketing_header">
          <div className="social_marketing_header_icon">
            <FaFacebookSquare />
          </div>
          <h1>Social Media Marketing</h1>
          <p>Manage your social media campaigns and content</p>
        </header>

        {/* Under Construction Notice */}
        <UnderConstruction pageName="Social Media Marketing" />
      </div>

      <DashboardFooter />
    </div>
  );
};

export default SocialMarketing; 